/* eslint max-len: 0 */
const icon = require('vue-svgicon')
icon.register({
  'incomplete': {
    viewBox: '0 0 32 32',
    data: `<path d="M16,1C7.7,1,1,7.7,1,16c0,8.3,6.7,15,15,15c8.3,0,15-6.7,15-15C31,7.7,24.3,1,16,1z M23.1,17H8.9c-0.6,0-1-0.4-1-1s0.4-1,1-1h14.1c0.6,0,1,0.4,1,1S23.6,17,23.1,17z"/>`
  }
})
